/**
 * Small, stable, non-cryptographic string hash (djb2) rendered as base36.
 * Used to derive a short cache-busting token from a cover art URL so a changed
 * upload (new S3 key) maps to a new cache key.
 */
export function hashString(input: string): string {
  let hash = 5381;
  for (let i = 0; i < input.length; i++) {
    hash = ((hash << 5) + hash + input.charCodeAt(i)) >>> 0;
  }
  return hash.toString(36);
}
